var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataTrue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 6.24907C36 6.96742 35.7832 7.57803 35.3497 8.08089L18.5342 27.5824L15.3755 31.2457C14.9419 31.7486 14.4155 32 13.7961 32C13.1768 32 12.6503 31.7486 12.2168 31.2457L9.05805 27.5824L0.65031 17.8315C0.21677 17.3288 0 16.7183 0 16C0 15.2817 0.21677 14.671 0.65031 14.1682L3.80904 10.5049C4.24258 10.0022 4.76903 9.75093 5.38839 9.75093C6.00775 9.75093 6.5342 10.0022 6.96774 10.5049L13.7961 18.4511L29.0323 0.7543C29.4658 0.251433 29.9922 0 30.6116 0C31.231 0 31.7574 0.251433 32.191 0.7543L35.3497 4.4176C35.7832 4.92023 36 5.53072 36 6.24907Z",
    fill: "#3BBD4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTrue);
export default __webpack_public_path__ + "static/media/data_true.1e72f519b498846c4f40b02bf8ab8e16.svg";
export { ForwardRef as ReactComponent };